import { Col, GRID } from '../../components/custom';

export default function BSM()
{
    return (
        <Col id='BSM' className='usecase'>
            <Col className='banner'>
                <span className='title'>Use Case: Brand Sentiment & Competitive Perception Monitoring</span>
                <span className='desc'>Reveal where your brand wins — and where competitors are vulnerable.</span>
            </Col>
            <Col className='section objective'>
                <span className='title'>The Business Context</span>
                <span className='descsmall'>A mid-market SaaS provider noticed a plateau in organic growth. They suspected it wasn't a product problem — it was a <strong>perception problem.</strong></span>
                <span className='descsmall'>Customers were choosing competitors despite similar offerings. Why?</span>
                <span className='descsmall'>We deployed our <strong>Customer Experience Intelligence Suite</strong> to decode unstructured sentiment across public reviews, forums, and feedback portals — and uncover the competitive perception landscape.</span>
            </Col>
            <Col className='section methodology'>
                <span className='title'>Methodology</span>
                <Col className='notTitle'>
                    <Col className='part'>
                        <span className='descsmall'>We scraped and analyzed <strong>600 reviews</strong> across three key brands — OurBrand, CompA, and CompB — from platforms like G2, Trustpilot, and in-app feedback.</span>
                    </Col>
                    <Col className='part'>
                        <span className='descsmall'>Our analysis included:</span>
                        <ul>
                            <li className='descsmall'><strong>NLP Sentiment Scoring</strong> of over 2,000 review snippets</li>
                            <li className='descsmall'><strong>Theme Tagging</strong> into 4 customer experience pillars: Support, Product, Pricing, Ease of Use</li>
                            <li className='descsmall'><strong>Regression-weighted scoring</strong> to quantify each category's impact on overall brand rating</li>
                        </ul>
                    </Col>
                </Col>
            </Col>
            <Col className='section results'>
                <span className='title'>Insights with Data</span>
                <Col className='notTitle'>
                    <Col className='part'>
                        <span className='desc'>Brand-Wise Average Category Scores (1-10 scale):</span>
                        <GRID className='_4x5'>
                            <span className='descsmall bold'>Experience Pillar</span>
                            <span className='descsmall bold'>Our Brand</span>
                            <span className='descsmall bold'>CompA</span>
                            <span className='descsmall bold'>CompB</span>
                            <span className='descsmall left'>Product</span>
                            <span className='descsmall bold'>7.03</span>
                            <span className='descsmall'>5.49</span>
                            <span className='descsmall'>5.34</span>
                            <span className='descsmall left'>Ease of Use</span>
                            <span className='descsmall bold'>7.09</span>
                            <span className='descsmall'>5.87</span>
                            <span className='descsmall'>5.56</span>
                            <span className='descsmall left'>Pricing</span>
                            <span className='descsmall bold'>6.84</span>
                            <span className='descsmall'>5.57</span>
                            <span className='descsmall bold'>4.99 👎</span>
                            <span className='descsmall left'>Support</span>
                            <span className='descsmall bold'>6.53</span>
                            <span className='descsmall'>5.73</span>
                            <span className='descsmall'>5.40</span>
                        </GRID>
                        <span className='descsmall'><strong>Our Brand led across all categories</strong>, but Pricing and Support were key gaps for <strong>CompB</strong>, where over <strong>35% of reviews were negative.</strong></span>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Sentiment Distribution</span>
                        <GRID className='_4x4'>
                            <span className='descsmall bold'>Brand</span>
                            <span className='descsmall bold'>Positive (%)</span>
                            <span className='descsmall bold'>Neutral (%)</span>
                            <span className='descsmall bold'>Negative (%)</span>
                            <span className='descsmall left'>OurBrand</span>
                            <span className='descsmall bold'>72%</span>
                            <span className='descsmall'>21%</span>
                            <span className='descsmall'>7%</span>
                            <span className='descsmall left'>CompA</span>
                            <span className='descsmall'>49%</span>
                            <span className='descsmall'>33%</span>
                            <span className='descsmall'>18%</span>
                            <span className='descsmall left'>CompB</span>
                            <span className='descsmall'>42%</span>
                            <span className='descsmall'>27%</span>
                            <span className='descsmall bold'>31% 🔥</span>
                        </GRID>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Statistical Highlights</span>
                        <ul>
                            <li className='descsmall'><strong>Chi-square test</strong> showed a statistically significant difference (p {'<'} 0.001) in review sentiment between OurBrand and competitors — strongest gap in the “Ease of Use” category.</li>
                            <li className='descsmall'>
                                <strong>Logistic regression</strong> revealed that:
                                <ul>
                                    <li className='descsmall'>Product satisfaction was <strong>2.4x more predictive</strong> of positive sentiment than Support quality.</li>
                                    <li className='descsmall'>Pricing dissatisfaction had the highest odds of predicting a negative review (odds ratio = <strong>3.2</strong>).</li>
                                </ul>
                            </li>
                        </ul>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Actionable Moves</span>
                        <ul>
                            <li className='descsmall'><strong>Marketing strategy update:</strong> Lead with “effortless UX” and “intuitive product” — both backed by data.</li>
                            <li className='descsmall'><strong>Campaign idea:</strong> “Work smart, not harder” targeting competitor's pain points.</li>
                            <li className='descsmall'><strong>Monitor alerts</strong> for competitive surges in Pricing complaints — a churn opportunity.</li>
                        </ul>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Outcomes</span>
                        <ul>
                            <li className='descsmall'>+17% lift in demo requests when ads used “rated #1 for ease of use” copy</li>
                            <li className='descsmall'>Competitive win rate improved by 11% in accounts where <strong>CompB</strong> was incumbent</li>
                            <li className='descsmall'>Quarterly brand tracker showed +9pt lift in “most user-friendly platform” perception</li>
                        </ul>
                    </Col>
                </Col>
            </Col>
        </Col>
    )
}